import React from 'react';

import { Block, withConfig } from '../common/Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import { Clickable, Hoverable } from '../common/Button.jsx';
import { Column, Row } from '../common/Container.jsx';
import Defaults from '../layout/Defaults.jsx';
import { FormContainer, withSubscriptionLogging, withValidationV2 } from '../common/Form.jsx';
import FormField from '../common/FormField.jsx';
import { Required, Text, Wrapper as InputWrapper } from '../common/Input.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';
import Token from '../common/Token.jsx';
import Url from '../common/Url.jsx';
import Utilities from '../common/Utilities.jsx';

// #region ADDRESS

function _AddressComponent(props) {
    let className = 'cont--address';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props);
    return (
        <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>
            {
                props.content != undefined &&
                <div className={className} style={layoutStyles.style}>
                    <div className="cont--token" dangerouslySetInnerHTML={{ __html: props.content }} style={{ lineHeight: 1 }} />
                </div>
            }
            {
                props.builder &&
                (props.content == undefined || props.content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
}
const AddressComponent = Token.withContentTokenParsing(_AddressComponent, {}, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.ArtistName:
        case Token.CompanyName:
            if (data.company && data.company.length > 0) {
                replaceString = Token.getReplacementString(data.company, options);
            }
            break;
        case Token.Address.City:
            if (data.city && data.city.length > 0) {
                replaceString = Token.getReplacementString(data.city, options);
            }
            break;
        case Token.Address.Country:
            if (data.country && data.country.length > 0) {
                replaceString = Token.getReplacementString(data.country, options);
            }
            break;
        case Token.Address.Line1:
            if (data.addressLineOne && data.addressLineOne.length > 0) {
                replaceString = Token.getReplacementString(data.addressLineOne, options);
            }
            break;
        case Token.Address.Line2:
            if (data.addressLineTwo && data.addressLineTwo.length > 0) {
                replaceString = Token.getReplacementString(data.addressLineTwo, options);
            }
            break;
        case Token.Address.State:
            if (data.state && data.state.length > 0) {
                replaceString = Token.getReplacementString(data.state, options);
            }
            break;
        case Token.Address.Zip:
            if (data.zip && data.zip.length > 0) {
                replaceString = Token.getReplacementString(data.zip, options);
            }
            break;
        case Token.ContactPageLink:
            if (data.contact && data.contact.relativeUrl && data.contact.relativeUrl.length > 0) {
                const link = Url.getLink(props.baseUrl, data.contact.relativeUrl, { sub: props.querySub, layout: props.queryLayout, dataSub: props.queryDataSub }, props.builder);
                replaceString = `<a href='${link}' style='color:inherit;'>${Token.getReplacementString(data.contact.title, options)}</a>`;
            }
            break;
        case Token.Phone:
            if (data.phone && data.phone.length > 0) {
                replaceString = `<a href='tel:${data.phone}'>${Token.getReplacementString(data.phone, options)}</a>`;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const AddressTokens = (pageType, config) => {
    let nameToken;
    if (config && config.userType == 1) {
        nameToken = Token.getWrappedTokenConfig('Artist Name', Token.ArtistName);
    } else {
        nameToken = Token.getWrappedTokenConfig('Company Name', Token.CompanyName);
    }
    const tokens = [
        nameToken,
        Token.getWrappedTokenConfig('Address Line 1', Token.Address.Line1),
        Token.getWrappedTokenConfig('Address Line 2', Token.Address.Line2),
        Token.getWrappedTokenConfig('City', Token.Address.City),
        Token.getWrappedTokenConfig('State', Token.Address.State),
        Token.getWrappedTokenConfig('Zip', Token.Address.Zip),
        Token.getWrappedTokenConfig('Country', Token.Address.Country),
        Token.getWrappedTokenConfig('Phone Number', Token.Phone)
    ];
    if (pageType == PageType.Footer) {
        tokens.push(Token.getWrappedTokenConfig('Link to Contact Page', Token.ContactPageLink))
    }
    return tokens;
}
const Address = { Component: AddressComponent, Tokens: AddressTokens };

// #endregion ADDRESS

// #region FORM V1 (-- DEPRECATED Use `ContactFormV2` --)

function _ContactFormV1Component(props) {
    React.useEffect(() => {
        if (!window || !window.location || !window.location.search) {
            return;
        }
        const query = Utilities.parseQueryString(window.location.search.substring(1));
        if (!query) {
            return;
        }
        if (query.inventoryId) {
            props.onChange('Id', query.inventoryId);
        }
        if (query.message) {
            props.onChange('Message', query.message);
        }
        if (query.subject) {
            props.onChange('Subject', query.subject);
        }
    }, [])

    React.useEffect(() => {
        if (!props.formData.token) {
            return;
        }
        const postData = {
            Id: props.formData.Id,
            Email: props.formData.Email,
            Message: props.formData.Message,
            Name: props.formData.Name,
            Phone: props.formData.Phone,
            Robots: props.formData.token,
            Sub: props.config.subdomain,
            Subject: props.formData.Subject
        }
        if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.tags && props.blockConfig.layout.tags.length > 0) {
            postData.Origin = props.blockConfig.layout.tags.map(d => d.value);
        }
        props.onSubmit('/api/contacts', postData);
    }, [props.formData.token])
    const buttonClassName = props.formData.formState != undefined ? ` btn--${props.formData.formState}` : '';
    const disabled = props.builder == true || props.disabled == true || props.formData.formState != undefined;
    let buttonHoverProps, buttonSpacing, buttonStyle, inputClassName, inputSpacing, inputStyle;
    if (props.blockConfig) {
        if (props.blockConfig.button) {
            buttonStyle = {};
            Block.mapStyleConfigProps(buttonStyle, props.blockConfig.button, (propName, propValue, propUnit) => {
                let _propValue = propValue;
                if (_propValue && propUnit) {
                    _propValue = `${_propValue}${propUnit}`;
                }
                switch (propName) {
                    case 'lineSpacing':
                        buttonSpacing = _propValue;
                        return true;
                    default:
                        if (propName.indexOf('Hover') < 0 || !_propValue) {
                            break;
                        }
                        if (!buttonHoverProps) {
                            buttonHoverProps = {};
                        }
                        const _propName = propName.replace('Hover', '');
                        buttonHoverProps[_propName] = _propValue;
                        return true;
                }
            });
        }
        if (props.blockConfig.input) {
            inputStyle = {};
            Block.mapStyleConfigProps(inputStyle, props.blockConfig.input, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'inputStyle':
                        inputClassName = `input--${propValue}`
                        return true;
                    case 'lineSpacing':
                        if (propValue && propUnit) {
                            inputSpacing = `${propValue}${propUnit}`;
                        }
                        return true;
                }
            });
        }
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props);
    if (props.builder || props.disabled) {
        layoutStyles.style.pointerEvents = 'none';
    }
    let className = 'form form--contact form--whitelabel__v1';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }

    let ButtonComponent = Clickable;
    if (buttonHoverProps != undefined) {
        ButtonComponent = Hoverable;
    }
    let content = (
        <form className={className} style={layoutStyles.style}>
            <Row>
                <Column size="12" style={{ marginBottom: inputSpacing }}>
                    <InputWrapper size="large">
                        <Required
                            className={inputClassName}
                            disabled={disabled}
                            errors={props.formData.errors}
                            name="Name"
                            placeholder="Full Name *"
                            style={inputStyle}
                            value={props.formData.Name}
                            onChange={props.onChange} />
                    </InputWrapper>
                </Column>
                <Column size="6" style={{ marginBottom: inputSpacing }}>
                    <InputWrapper size="large">
                        <Required
                            className={inputClassName}
                            disabled={disabled}
                            errors={props.formData.errors}
                            name="Email"
                            placeholder="Email Address *"
                            style={inputStyle}
                            type="email"
                            value={props.formData.Email}
                            onChange={props.onChange} />
                    </InputWrapper>
                </Column>
                <Column size="6" style={{ marginBottom: inputSpacing }}>
                    <InputWrapper size="large">
                        <Text
                            className={inputClassName}
                            disabled={disabled}
                            name="Phone"
                            placeholder="Phone Number"
                            style={inputStyle}
                            value={props.formData.Phone || ''}
                            onChange={props.onChange} />
                    </InputWrapper>
                </Column>
                <Column size="12" style={{ marginBottom: inputSpacing }}>
                    <InputWrapper size="large">
                        <Required
                            className={inputClassName}
                            disabled={disabled}
                            errors={props.formData.errors}
                            name="Subject"
                            placeholder="Subject *"
                            style={inputStyle}
                            value={props.formData.Subject}
                            onChange={props.onChange} />
                    </InputWrapper>
                </Column>
                <Column size="12">
                    <InputWrapper className="input--area" size="large">
                        <Required
                            className={inputClassName}
                            cols="30"
                            disabled={disabled}
                            errors={props.formData.errors}
                            name="Message"
                            placeholder="Your Message..."
                            rows="10"
                            style={inputStyle}
                            type="textarea"
                            value={props.formData.Message}
                            onChange={props.onChange} />
                    </InputWrapper>
                </Column>
                <Column size="12" style={{ marginTop: buttonSpacing }}>
                    <ButtonComponent
                        className={`btn btn--outl btn--lg form__btn${buttonClassName}`}
                        disabled={disabled}
                        hoverProps={buttonHoverProps}
                        style={buttonStyle}
                        type="submit"
                        onClick={props.onValidate}>
                        <React.Fragment><div className="submission-status" /> {props.formData.formState == 'success' ? 'Message Sent' : 'Send message'}</React.Fragment>
                    </ButtonComponent>
                </Column>
            </Row>
        </form>
    );
    if (layoutStyles.containerStyle) {
        content = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{content}</div>
    }
    if (props.onContent) {
        content = props.onContent(content)
    }
    return content;
}
const ContactFormV1Component =
    withConfig(
        withSubscriptionLogging(
            withValidationV2(
                _ContactFormV1Component,
                ['Email', 'Message', 'Name', 'Subject']
            ),
            'page'));
const ContactFormV1 = { Component: ContactFormV1Component };

// #endregion FORM V1

// #region CONTACT FORM V2

function _ContactFormV2Component(props) {
    React.useEffect(() => {
        if (!window || !window.location || !window.location.search) {
            return;
        }
        const query = Utilities.parseQueryString(window.location.search.substring(1));
        if (!query) {
            return;
        }
        if (query.inventoryId) {
            props.onChange('Id', query.inventoryId);
        }
        if (query.message) {
            props.onChange('Message', query.message);
        }
        if (query.subject) {
            props.onChange('Subject', query.subject);
        }
    }, [])
    React.useEffect(() => {
        if (!props.formData.token) {
            return;
        }
        const postData = {
            AddressLineOne: props.formData.AddressLineOne,
            AddressLineTwo: props.formData.AddressLineTwo,
            City: props.formData.City,
            Country: props.formData.Country,
            Email: props.formData.Email,
            Id: props.formData.Id,
            Message: props.formData.Message,
            Name: props.formData.Name,
            Phone: props.formData.Phone,
            Robots: props.formData.token,
            State: props.formData.State,
            Sub: props.config.subdomain,
            Subject: props.formData.Subject,
            Zip: props.formData.Zip
        }
        if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.tags && props.blockConfig.layout.tags.length > 0) {
            postData.Origin = props.blockConfig.layout.tags.map(d => d.value);
        }
        props.onSubmit('/api/contacts', postData);
    }, [props.formData.token])

    let additionalFields = [];
    const handleValidate = () => props.onValidate(additionalFields);
    const handleFormFieldProps = React.useCallback(({ blockConfig, type }, formFieldProps) => {
        switch (type) {
            case FormField.Email:
                formFieldProps.placeholderText = 'Email Address *';
                formFieldProps.type = 'email';
                formFieldProps.onSubmit = handleValidate;
                break;
            case FormField[Name.Block.Contact.Form.Container].ErrorMessage:
                formFieldProps.editor = props.editor;
                formFieldProps.error = props.formData.errorMessage;
                break;
            case FormField.Message:
                formFieldProps.placeholderText = 'Your Message...';
                formFieldProps.rows = "8";
                formFieldProps.type = 'textarea';
                break;
            case FormField.Name:
                formFieldProps.placeholderText = 'Full Name *';
                formFieldProps.onSubmit = handleValidate;
                break;
            case FormField.Phone:
                formFieldProps.placeholderText = 'Phone Number';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.AddressLine1:
                formFieldProps.placeholderText = 'Address Line 1';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.AddressLine2:
                formFieldProps.placeholderText = 'Address Line 2';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.City:
                formFieldProps.placeholderText = 'City';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.Country:
                formFieldProps.placeholderText = 'Country';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.State:
                formFieldProps.placeholderText = 'State';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.ShippingAddress.Zip:
                formFieldProps.placeholderText = 'Zip';
                formFieldProps.required = blockConfig && blockConfig.block && blockConfig.block.required;
                formFieldProps.onSubmit = handleValidate;

                if (formFieldProps.required) {
                    formFieldProps.placeholderText = `${formFieldProps.placeholderText} *`;
                    additionalFields.push(type);
                }
                break;
            case FormField.Subject:
                formFieldProps.placeholderText = 'Subject *';
                formFieldProps.onSubmit = handleValidate;
                break;
            case FormField[Name.Block.Contact.Form.Container].SubmitButtonV1:
            case FormField[Name.Block.Contact.Form.Container].SubmitButtonV2:
                formFieldProps.artist = props.data && props.data.artist;
                formFieldProps.formState = props.formData.formState;
                formFieldProps.onClick = handleValidate;
                break;
            case FormField[Name.Block.Contact.Form.Container].SuccessMessage:
                formFieldProps.artist = props.data && props.data.artist;
                formFieldProps.editor = props.editor;
                formFieldProps.formState = props.formData.formState;
                break;
        }
    }, [props.formData.errorMessage, props.formData.formState]);
    let contentConfig = props.contentConfig;
    if (!contentConfig) {
        if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.design && props.blockConfig.layout.design.desktop && props.blockConfig.layout.design.desktop.blocks && props.blockConfig.layout.design.desktop.blocks.length > 0) {
            contentConfig = props.blockConfig.layout.design;
        } else {
            contentConfig = Defaults.Block[Name.Block.Contact.Form.Container];
        }
    }
    return (
        <FormContainer.Component
            {...props}
            contentConfig={contentConfig}
            onFormFieldProps={handleFormFieldProps} />
    );
}
const ContactFormV2Component =
    withSubscriptionLogging(
        withValidationV2(
            _ContactFormV2Component,
            ['Email', 'Message', 'Name', 'Subject']
        ),
        'page');
const ContactFormV2 = { Component: ContactFormV2Component };

// #endregion CONTACT FORM V2

// #region HOURS

function HoursComponent(props) {
    const hasContent = props.config && props.config.hours && props.config.hours.length > 0;
    if (!props.builder && !hasContent) {
        return null;
    }
    let style = { lineHeight: 1 };
    let design, lineItemStyle;
    if (props.blockConfig && props.blockConfig.block) {
        lineItemStyle = {};
        Block.mapStyleConfigProps(lineItemStyle, props.blockConfig.block, (propName, propValue, propUnit) => {
            switch (propName) {
                case 'design':
                    design = propValue;
                    return true;
                case 'direction':
                    if (propValue == 'row') {
                        style.display = 'flex';
                    }
                    return true;
                case 'lineSpacing':
                    if (propValue == undefined || propUnit == undefined) {
                        return true;
                    }
                    let value = propValue / 2;
                    value = `${value}${propUnit}`;
                    switch (props.blockConfig.block.direction) {
                        case 'column':
                            lineItemStyle.marginBottom = value;
                            lineItemStyle.paddingBottom = value;
                            break;
                        case 'row':
                            lineItemStyle.marginRight = value;
                            lineItemStyle.paddingRight = value;
                            break;
                    }
                    return true;
                case 'textAlign':
                    if (props.blockConfig.block.direction == 'row') {
                        switch (propValue) {
                            case 'center':
                                style.justifyContent = 'center';
                                break;
                            case 'left':
                                style.justifyContent = 'flex-start';
                                break;
                            case 'right':
                                style.justifyContent = 'flex-end';
                                break;
                        }
                        return true;
                    }
                    break;
            }
        });
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props);
    let content = [];
    if (props.config && props.config.hours) {
        content = props.config.hours.map((d, i) => {
            let _style = lineItemStyle;
            if (i == props.config.hours.length - 1) {
                _style = {};
                Utilities.copyObject(lineItemStyle, _style);
                _style.borderRightColor = undefined;
                _style.borderRightStyle = undefined;
                _style.borderRightWidth = undefined;
                _style.marginBottom = 0;
                _style.marginRight = 0;
                _style.paddingBottom = 0;
                _style.paddingRight = 0;
            }
            let display;
            if (design) {
                display = Token.parseTokenizedString(design, () => d);
            } else {
                display = `<span>${d}</span>`;
            }
            return <div key={i} dangerouslySetInnerHTML={{ __html: display }} style={_style} />
        });
    }
    let className = 'cont--hours richText';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    return (
        <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>
            {
                hasContent &&
                <div className={className} style={layoutStyles.style}>
                    {content}
                </div>
            }
            {
                props.builder &&
                !hasContent &&
                <EmptyPlaceholder />
            }
        </div>
    )
}
const Hours = { Component: HoursComponent };

// #endregion HOURS

export {
    Address,
    ContactFormV2,
    Hours,

    // DEPRECATED
    ContactFormV1
}